export var buttonTransitionStyle = "\n  transition: transform 0.1s ease-out, background-color 0.1s ease-out, color 0.1s ease-out, box-shadow 0.2s ease-out;\n";